<script>
    import { onMount } from "svelte";
    import * as Common from "../utiles/common.util";
    import { push } from "svelte-spa-router";
    import * as api from "../utiles/api";
    import { Preferences } from "@capacitor/preferences";
    import toast from "svelte-french-toast";

    let login_id = "";
    let key_no = "";

    onMount(async () => {
        // 이미 로그인 정보가 있으면 출하등록관리로 이동
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            push("/Menu");
        } else {
            // 저장된 아이디 불러오기
            const savedId = await Preferences.get({ key: "retech_saved_id" });
            if (savedId.value) {
                login_id = savedId.value;
            }
        }
    });

    async function login() {
        if (Common.nullCheck(login_id, "login_id", "아이디")) return;
        if (Common.nullCheck(key_no, "key_no", "비밀번호")) return;

        const formData = {
            login_id,
            key_no,
        };

        try {
            const response = await api.post("/account/login", formData);

            if (response != null) {
                const userData = response.data;

                // 1. Preferences (모바일 영구 저장) 저장
                await Preferences.set({
                    key: "retechInfo",
                    value: JSON.stringify(userData),
                });
                await Preferences.set({
                    key: "retech_jwt_token",
                    value: response.token.jwt_token,
                });
                await Preferences.set({
                    key: "retech_refresh_token",
                    value: response.token.refresh_token,
                });

                // 최근 성공한 아이디 저장
                await Preferences.set({
                    key: "retech_saved_id",
                    value: login_id,
                });

                toast.success(`${userData.empl_nm}님 환영합니다!`);

                // 2. 페이지 이동
                push("/Menu");
            } else {
                toast.error("로그인에 실패했습니다.");
            }
        } catch (error) {
            toast.error("로그인 중 오류가 발생했습니다.");
        }
    }
</script>

<div class="login-container">
    <div class="background-blobs">
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
        <div class="blob blob-3"></div>
    </div>

    <div class="login-card">
        <div class="header">
            <div class="logo">
                <span class="logo-text">RETECH</span>
                <div class="logo-underline"></div>
            </div>
            <h1>MES 생산관리 시스템</h1>
            <p>스마트 팩토리 솔루션에 오신 것을 환영합니다</p>
        </div>

        <form class="form-container" on:submit|preventDefault={login}>
            <div class="input-group">
                <label for="login_id">아이디</label>
                <div class="input-wrapper">
                    <input
                        id="login_id"
                        name="username"
                        type="text"
                        bind:value={login_id}
                        placeholder="아이디를 입력하세요"
                        autocomplete="username"
                    />
                    <span class="input-icon">👤</span>
                </div>
            </div>

            <div class="input-group">
                <label for="key_no">비밀번호</label>
                <div class="input-wrapper">
                    <input
                        id="key_no"
                        name="password"
                        type="password"
                        bind:value={key_no}
                        placeholder="********"
                        autocomplete="current-password"
                    />
                    <span class="input-icon">🔒</span>
                </div>
            </div>

            <button type="submit" class="login-button">로그인</button>
        </form>
    </div>
</div>

<style>
    :global(body) {
        margin: 0;
        padding: 0;
        font-family:
            "Pretendard",
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            Roboto,
            Helvetica,
            Arial,
            sans-serif;
        background-color: #0f172a;
    }

    .login-container {
        position: relative;
        min-height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2vh 20px;
        box-sizing: border-box;
        overflow-y: auto;
    }

    /* Background Animation */
    .background-blobs {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 0;
        filter: blur(80px);
        opacity: 0.6;
        pointer-events: none;
    }

    .blob {
        position: absolute;
        border-radius: 50%;
        animation: float 20s infinite alternate;
    }

    .blob-1 {
        width: 500px;
        height: 500px;
        background: #3b82f6;
        top: -100px;
        left: -100px;
        opacity: 0.4;
    }

    .blob-2 {
        width: 400px;
        height: 400px;
        background: #8b5cf6;
        bottom: -50px;
        right: -50px;
        animation-delay: -5s;
        opacity: 0.3;
    }

    .blob-3 {
        width: 300px;
        height: 300px;
        background: #ec4899;
        top: 40%;
        left: 60%;
        animation-delay: -10s;
        opacity: 0.2;
    }

    @keyframes float {
        0% {
            transform: translate(0, 0) rotate(0deg) scale(1);
        }
        33% {
            transform: translate(30px, 50px) rotate(120deg) scale(1.1);
        }
        66% {
            transform: translate(-20px, 80px) rotate(240deg) scale(0.9);
        }
        100% {
            transform: translate(0, 0) rotate(360deg) scale(1);
        }
    }

    /* Login Card */
    .login-card {
        position: relative;
        z-index: 10;
        width: 100%;
        max-width: 480px;
        padding: clamp(1.5rem, 5vh, 3.5rem);
        margin: auto;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 2rem;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: slideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1);
        display: flex;
        flex-direction: column;
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(40px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .header {
        text-align: center;
        margin-bottom: clamp(1rem, 3vh, 2.5rem);
    }

    .logo {
        display: inline-block;
        margin-bottom: 0.5rem;
    }

    .logo-text {
        font-size: clamp(1.5rem, 5vh, 2.5rem);
        font-weight: 900;
        color: #1e40af;
        letter-spacing: -1px;
    }

    .logo-underline {
        height: 4px;
        width: 40%;
        background: linear-gradient(90deg, #3b82f6, transparent);
        margin: -4px auto 0;
        border-radius: 2px;
    }

    .header h1 {
        font-size: clamp(1rem, 2vh, 1.25rem);
        font-weight: 700;
        color: #334155;
        margin: 0.25rem 0 0.125rem;
    }

    .header p {
        font-size: 0.875rem;
        color: #64748b;
        margin: 0;
    }

    /* Inputs */
    .form-container {
        display: flex;
        flex-direction: column;
        gap: clamp(0.75rem, 2vh, 1.5rem);
    }

    .input-group {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }

    .input-group label {
        font-size: 0.8125rem;
        font-weight: 600;
        color: #475569;
        margin-left: 0.25rem;
    }

    .input-wrapper {
        position: relative;
    }

    .input-wrapper input {
        width: 100%;
        height: clamp(2.75rem, 6vh, 3.5rem);
        padding: 0 1rem 0 3rem;
        border: 2px solid #e2e8f0;
        border-radius: 1rem;
        font-size: 1rem;
        color: #1e293b;
        background: #f8fafc;
        transition: all 0.3s ease;
        box-sizing: border-box;
    }

    .input-wrapper input:focus {
        outline: none;
        border-color: #3b82f6;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
    }

    .input-icon {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.25rem;
        opacity: 0.5;
    }

    /* Button */
    .login-button {
        height: clamp(3rem, 7vh, 3.75rem);
        margin-top: 0.5rem;
        background: linear-gradient(135deg, #2563eb, #1e40af);
        color: white;
        border: none;
        border-radius: 1rem;
        font-size: 1.125rem;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3);
    }

    .login-button:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 20px 25px -5px rgba(37, 99, 235, 0.4);
        background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    }

    .login-button:active:not(:disabled) {
        transform: translateY(0);
    }

    .login-button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    /* Tablet/Mobile Landscape Optimization */
    @media (max-height: 700px) {
        .login-card {
            padding: 6rem 2rem;
        }
        .header {
            margin-bottom: 0.5rem;
        }
        .logo-text {
            font-size: 1.5rem;
        }
        .form-container {
            gap: 0.25rem;
        }
        .login-container {
            padding: 10px 20px;
        }
    }

    @media (max-width: 768px) {
        .login-card {
            max-width: 90%;
            padding: 2rem;
        }
    }
</style>
